import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableDefaultVariants = {}
const tableCompoundVariants = []

const tableSlotNames = [
  [
    "container",
    "tableRecipe__container"
  ],
  [
    "table",
    "tableRecipe__table"
  ],
  [
    "header",
    "tableRecipe__header"
  ],
  [
    "head",
    "tableRecipe__head"
  ],
  [
    "body",
    "tableRecipe__body"
  ],
  [
    "row",
    "tableRecipe__row"
  ],
  [
    "cell",
    "tableRecipe__cell"
  ]
]
const tableSlotFns = /* @__PURE__ */ tableSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableDefaultVariants, getSlotCompoundVariant(tableCompoundVariants, slotName))])

const tableFn = memo((props = {}) => {
  return Object.fromEntries(tableSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableVariantKeys = []
const getVariantProps = (variants) => ({ ...tableDefaultVariants, ...compact(variants) })

export const table = /* @__PURE__ */ Object.assign(tableFn, {
  __recipe__: false,
  __name__: 'table',
  raw: (props) => props,
  variantKeys: tableVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, tableVariantKeys)
  },
  getVariantProps
})